export default __webpack_public_path__ + "static/media/Snd_M_Starts.5a1f65b3.mp3";